// Font loading optimization utility
export const optimizeFontLoading = () => {
  // Check if fonts are already loaded
  if ('fonts' in document) {
    // Load Inter font using the correct Google Fonts CSS API
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap';
    link.rel = 'stylesheet';
    link.onload = () => {
      document.documentElement.classList.add('inter-loaded');
    };
    link.onerror = () => {
      console.warn('Inter font failed to load, using system fonts');
    };
    document.head.appendChild(link);
  } else {
    // Fallback for browsers without Font Loading API
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap';
    link.rel = 'stylesheet';
    link.onload = () => {
      document.documentElement.classList.add('inter-loaded');
    };
    document.head.appendChild(link);
  }
};

// Preload critical resources
export const preloadCriticalResources = () => {
  // Remove the broken font preload and focus on other critical resources
  const criticalResources = [
    // Preload critical images
    {
      href: '/images/favicon.ico',
      as: 'image',
      type: 'image/x-icon'
    },
    {
      href: '/images/The-Random-Store---Logo---Transparent - Copy.png',
      as: 'image',
      type: 'image/png'
    }
  ];

  criticalResources.forEach(resource => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = resource.href;
    link.as = resource.as;
    if (resource.type) link.type = resource.type;
    if (resource.crossorigin) link.crossOrigin = resource.crossorigin;
    document.head.appendChild(link);
  });
};

// Initialize font optimization
export const initFontOptimization = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      preloadCriticalResources();
      optimizeFontLoading();
    });
  } else {
    preloadCriticalResources();
    optimizeFontLoading();
  }
};
